import { useContext } from "react";

import { SprintAccessRight } from "./SprintAccessRight";
import { UserContext } from "./UserProvider";

export const useAccessVerifier = () => {
    const { accessRights } = useContext(UserContext);

    const isAuthorized = (requiredAccessRight: SprintAccessRight[]) => {
        if (requiredAccessRight.every((accessRight: SprintAccessRight) => accessRights.includes(accessRight))) {
            return true;
        }

        return false;
    };

    return {
        isAuthorized
    };
};
